// This is the new code to PASTE
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import {
    Box, Card, CardContent, Collapse, IconButton, Typography, Dialog,
    DialogTitle, DialogContent, DialogActions, TextField, Chip, Button,
    Select, MenuItem, FormControl, InputLabel, CircularProgress, Alert,
    Paper, Divider, Rating, Grid, Tooltip, FormControlLabel, Checkbox,
    Avatar, Stack // Added Avatar and Stack
} from '@mui/material';
import {
    ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon, Star as StarIcon,
    Share as ShareIcon, StarBorder as StarBorderIcon, AttachFile as AttachFileIcon,
    Search as SearchIcon, Clear as ClearIcon, Reply as ReplyIcon,
    Chat as ChatIcon, Feedback as FeedbackIcon, CheckCircle as CheckCircleIcon,
    HourglassEmpty as PendingIcon, Error as ErrorIcon, Schedule as ScheduleIcon,
    CalendarToday as CalendarIcon, Edit as EditIcon, Article as ArticleIcon,
    PersonOutline as PersonOutlineIcon, SmartToyOutlined as SmartToyIcon // Added new icons
} from '@mui/icons-material';
import {
    collection, query, where, orderBy, onSnapshot, or, and, doc,
    updateDoc, arrayUnion, arrayRemove, addDoc, serverTimestamp
} from 'firebase/firestore';
import { db } from '../../firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { toast } from 'react-toastify';
import { Document, Packer, Paragraph, TextRun, HeadingLevel } from 'docx';
import ShareModal from '../ShareModal';
import BEPMemoDisplay from '../DecisionMemo/BEPMemoDisplay'; // NEW: Import BEP component

// Isolated search input to prevent parent re-renders on every keystroke
const SearchInput = React.memo(({ onSearch, onClear }) => {
    const [inputValue, setInputValue] = React.useState('');
    
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onSearch(inputValue);
        }
    };
    
    const handleClear = () => {
        setInputValue('');
        onClear();
    };

    const handleSearchClick = () => {
        onSearch(inputValue);
    };
    
    return (
        <Box sx={{ display: 'flex', gap: 1 }}>
            <TextField
                placeholder="Search and press Enter..."
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                size="small"
                fullWidth
                InputProps={{
                    startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
                    endAdornment: inputValue && (
                        <IconButton size="small" onClick={handleClear}>
                            <ClearIcon />
                        </IconButton>
                    )
                }}
            />
            <Button
                variant="contained"
                onClick={handleSearchClick}
                size="small"
                disabled={!inputValue.trim()}
                sx={{ height: '40px', minWidth: '80px' }}
            >
                Search
            </Button>
        </Box>
    );
});

// This is the new code to PASTE
const AdminExistingQuestions = ({
    clientId,
    user,
    clientIsActive,
    clients,
    onQuestionUpdate,
    isAdmin // Add isAdmin here
}) => {
    console.log('[DEBUG] AdminExistingQuestions RECEIVED props:', { clientId, isAdmin });
    // State hooks from your source file
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedQuestions, setExpandedQuestions] = useState(new Set());
    const [shareModalOpen, setShareModalOpen] = useState(false);
    const [selectedQuestionForShare, setSelectedQuestionForShare] = useState(null);
    const [selectedQuestionForNote, setSelectedQuestionForNote] = useState(null);
    const [noteDialogOpen, setNoteDialogOpen] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [exportFields, setExportFields] = useState({
        questionId: false,
        clientName: true,
        questionText: true,
        answerText: true,
        dateCreated: true,
        feedbackRating: false,
        feedbackText: false,
        userNotes: false,
        includeFollowUps: true
    });
    const [isExporting, setIsExporting] = useState(false);
    const [exportFormat, setExportFormat] = useState('csv');
    const [localSearchQuery, setLocalSearchQuery] = useState('');
    const [localSortOption, setLocalSortOption] = useState('newest');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    // searchInput state removed - now isolated in SearchInput component
    const [followUpDialogOpen, setFollowUpDialogOpen] = useState(false);
    const [selectedQuestionForFollowUp, setSelectedQuestionForFollowUp] = useState(null);
    const [followUpText, setFollowUpText] = useState('');
    const [submittingFollowUp, setSubmittingFollowUp] = useState(false);
    const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
    const [selectedQuestionForFeedback, setSelectedQuestionForFeedback] = useState(null);
    const [feedbackRating, setFeedbackRating] = useState(0);
    const [feedbackText, setFeedbackText] = useState('');
    const [submittingFeedback, setSubmittingFeedback] = useState(false);
    const [buFollowUpDialogOpen, setBuFollowUpDialogOpen] = useState(false);
    const [selectedUpdateForFollowUp, setSelectedUpdateForFollowUp] = useState(null);
    const [buFollowUpText, setBuFollowUpText] = useState('');

  // This is the new code to PASTE
    // Helper function to highlight search terms
const highlightSearchTerms = (text, searchTerm) => {
    if (!searchTerm || !text) return text;
    const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);
    return parts.map((part, index) =>
        regex.test(part) ? (
            <span key={index} style={{ backgroundColor: '#ffeb3b', fontWeight: 'bold' }}>
                {part}
            </span>
        ) : part
    );
};

// Helper to process React children and apply highlighting to text nodes
const processTextChildren = (children, searchTerm) => {
    if (!searchTerm) return children;
    return React.Children.map(children, child => {
        if (typeof child === 'string') {
            return highlightSearchTerms(child, searchTerm);
        }
        return child;
    });
};

// Custom ReactMarkdown components that apply search highlighting
const getHighlightedMarkdownComponents = (searchTerm) => {
    if (!searchTerm?.trim()) return {};
    return {
        p: ({children, ...props}) => <p {...props}>{processTextChildren(children, searchTerm)}</p>,
        li: ({children, ...props}) => <li {...props}>{processTextChildren(children, searchTerm)}</li>,
        td: ({children, ...props}) => <td {...props}>{processTextChildren(children, searchTerm)}</td>,
        th: ({children, ...props}) => <th {...props}>{processTextChildren(children, searchTerm)}</th>,
        strong: ({children, ...props}) => <strong {...props}>{processTextChildren(children, searchTerm)}</strong>,
        em: ({children, ...props}) => <em {...props}>{processTextChildren(children, searchTerm)}</em>,
    };
};

    // Handle favorite toggle
    const handleFavoriteToggle = async (questionId, currentlyFavorited) => {
        const userId = user?.uid || user?.id;
        if (!userId) return;
        try {
            const questionRef = doc(db, 'questions', questionId);
            if (currentlyFavorited) {
                await updateDoc(questionRef, {
                    favoritedBy: arrayRemove(userId)
                });
                toast.success('Removed from favorites');
            } else {
                await updateDoc(questionRef, {
                    favoritedBy: arrayUnion(userId)
                });
                toast.success('Added to favorites');
            }
        } catch (error) {
            console.error('Error updating favorite status:', error);
            toast.error('Failed to update favorite status');
        }
    };

    // Check if question is favorited by current user
    const isQuestionFavorited = (question) => {
        const userId = user?.uid || user?.id;
        return question.favoritedBy && question.favoritedBy.includes(userId);
    };

    // Handle favorite toggle for Business Updates
const handleUpdateFavoriteToggle = async (updateId, currentlyFavorited) => {
    // This function is admin-only view, so we don't implement the update logic.
    // We keep the function here to prevent crashes if it were ever called.
    console.log("Admin view: Favorite toggle disabled for Business Updates.");
};

// Check if a business update is favorited by any user
const isUpdateFavorited = (update) => {
    return update.favoritedBy && update.favoritedBy.length > 0;
};

// Generic favorite checker for sorting
const isItemFavorited = (item) => {
    if (item.dataType === 'question') {
        return isQuestionFavorited(item);
    }
    if (item.dataType === 'update') {
        return isUpdateFavorited(item);
    }
    return false;
};

// Generic handler for sharing any item
const handleShareItem = useCallback((item) => {
    // In the admin portal, the share button is hidden, 
    // but we keep the handler to prevent crashes.
    console.log("Admin view: Sharing disabled.");
}, []);

    // Handle feedback submission
    const handleFeedbackSubmit = async () => {
        if (!selectedQuestionForFeedback || feedbackRating === 0) return;
        const userId = user?.uid || user?.id;
        if (!userId) {
            toast.error('User not authenticated');
            return;
        }
        setSubmittingFeedback(true);
        try {
            const questionRef = doc(db, 'questions', selectedQuestionForFeedback.id);
            const feedbackData = {
                rating: feedbackRating,
                comment: feedbackText.trim(),
                submittedAt: serverTimestamp(),
                submittedBy: user.email
            };
            await updateDoc(questionRef, {
                feedback: feedbackData,
                updatedAt: serverTimestamp()
            });
            toast.success('Feedback submitted successfully!');
            setFeedbackDialogOpen(false);
            setFeedbackRating(0);
            setFeedbackText('');
            setSelectedQuestionForFeedback(null);
            if (onQuestionUpdate) onQuestionUpdate();
        } catch (error) {
            console.error('Error submitting feedback:', error);
            toast.error('Failed to submit feedback');
        } finally {
            setSubmittingFeedback(false);
        }
    };

    // Handle follow-up submission
    const handleFollowUpSubmit = async () => {
        if (!followUpText.trim() || !selectedQuestionForFollowUp) return;
        const userId = user?.uid || user?.id;
        if (!userId) {
            toast.error('User not authenticated');
            return;
        }
        setSubmittingFollowUp(true);
        try {
            const followUpData = {
                questionText: followUpText.trim(),
                parentId: selectedQuestionForFollowUp.id,
                clientId: selectedQuestionForFollowUp.clientId,
                userId: userId,
                fcfoId: userId, // For compatibility
                userEmail: user.email,
                type: 'follow-up',
                status: 'pending',
                aiStatus: 'processing',
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            };
            await addDoc(collection(db, 'questions'), followUpData);
            toast.success('Follow-up question submitted successfully!');
            setFollowUpDialogOpen(false);
            setFollowUpText('');
            setSelectedQuestionForFollowUp(null);
            if (onQuestionUpdate) onQuestionUpdate();
        } catch (error) {
            console.error('Error submitting follow-up question:', error);
            toast.error('Failed to submit follow-up question');
        } finally {
            setSubmittingFollowUp(false);
        }
    };

    // Handle share button click
    const handleShareClick = useCallback((question) => {
        setSelectedQuestionForShare(question);
        setShareModalOpen(true);
    }, []);

    // Handle edit note button click
    const handleEditNote = useCallback((question) => {
        setSelectedQuestionForNote(question);
        setNoteText(question.userNotes || '');
        setNoteDialogOpen(true);
    }, []);

    // Handle save note
    const handleSaveNote = useCallback(async (questionId) => {
        if (!questionId) return;
        try {
            const questionRef = doc(db, 'questions', questionId);
            await updateDoc(questionRef, {
                userNotes: noteText.trim(),
                updatedAt: serverTimestamp()
            });
            toast.success('Note saved successfully!');
            setNoteDialogOpen(false);
            setSelectedQuestionForNote(null);
            setNoteText('');
        } catch (error) {
            console.error('Error saving note:', error);
            toast.error('Failed to save note');
        }
    }, [noteText]);

    // Generate CSV content
    const generateCSVContent = (questions, selectedFields) => {
        const headers = [];
        const fieldMap = {
            questionId: 'Question ID', clientName: 'Client Name', questionText: 'Question Text',
            answerText: 'Answer Text', dateCreated: 'Date Created', feedbackRating: 'Feedback Rating',
            feedbackText: 'Feedback Comments', userNotes: 'User Notes'
        };
        Object.keys(selectedFields).forEach(field => {
            if (selectedFields[field] && fieldMap[field]) {
                headers.push(fieldMap[field]);
            }
        });
        const rows = [headers];
        questions.forEach(question => {
            const row = [];
            Object.keys(selectedFields).forEach(field => {
                if (selectedFields[field]) {
                    switch (field) {
                        case 'questionId': row.push(question.id || ''); break;
                        case 'clientName': row.push(question.clientName || ''); break;
                        case 'questionText': row.push(question.questionText || ''); break;
                        case 'answerText': row.push(question.answer || ''); break;
                        case 'dateCreated': row.push(question.createdAt?.toDate ? question.createdAt.toDate().toLocaleDateString() : ''); break;
                        case 'feedbackRating': row.push(question.feedback?.rating || ''); break;
                        case 'feedbackText': row.push(question.feedback?.comment || ''); break;
                        case 'userNotes': row.push(question.userNotes || ''); break;
                        default: row.push('');
                    }
                }
            });
            rows.push(row);
            if (selectedFields.includeFollowUps && question.followUps?.length > 0) {
                question.followUps.forEach(followUp => {
                    const followUpRow = [];
                    Object.keys(selectedFields).forEach(field => {
                        if (selectedFields[field]) {
                            switch (field) {
                                case 'questionId': followUpRow.push(followUp.id || ''); break;
                                case 'clientName': followUpRow.push(question.clientName || ''); break;
                                case 'questionText': followUpRow.push(`[Follow-up] ${followUp.questionText}` || ''); break;
                                case 'answerText': followUpRow.push(followUp.answer || ''); break;
                                case 'dateCreated': followUpRow.push(followUp.createdAt?.toDate ? followUp.createdAt.toDate().toLocaleDateString() : ''); break;
                                default: followUpRow.push('');
                            }
                        }
                    });
                    rows.push(followUpRow);
                });
            }
        });
        return rows.map(row =>
            row.map(cell => `"${(cell || '').toString().replace(/"/g, '""')}"`).join(',')
        ).join('\n');
    };

    // Generate Word document
    const generateWordDocument = async (questions, selectedFields) => {
        const children = [];
        children.push(
            new Paragraph({ text: "SavvaiSignals ™ Export", heading: HeadingLevel.TITLE }),
            new Paragraph({ text: `Export Date: ${new Date().toLocaleDateString()}`, spacing: { after: 200 } }),
            new Paragraph({ text: `Total Questions: ${questions.length}`, spacing: { after: 400 } })
        );
        questions.forEach((question, index) => {
            children.push(new Paragraph({ text: `Question ${index + 1}`, heading: HeadingLevel.HEADING_1, spacing: { before: 300, after: 100 } }));
            if (selectedFields.questionId) {
                children.push(new Paragraph({ children: [new TextRun({ text: "Question ID: ", bold: true }), new TextRun({ text: question.id || 'N/A' })], spacing: { after: 100 } }));
            }
            if (selectedFields.clientName && question.clientName) {
                children.push(new Paragraph({ children: [new TextRun({ text: "Client: ", bold: true }), new TextRun({ text: question.clientName })], spacing: { after: 100 } }));
            }
            if (selectedFields.questionText) {
                children.push(new Paragraph({ children: [new TextRun({ text: "Question: ", bold: true }), new TextRun({ text: question.questionText || 'N/A' })], spacing: { after: 100 } }));
            }
            if (selectedFields.answerText && question.answer) {
                children.push(new Paragraph({ children: [new TextRun({ text: "Answer: ", bold: true }), new TextRun({ text: question.answer })], spacing: { after: 100 } }));
            }
            if (selectedFields.userNotes && question.userNotes) {
                children.push(new Paragraph({ children: [new TextRun({ text: "Your Notes: ", bold: true }), new TextRun({ text: question.userNotes })], spacing: { after: 100 } }));
            }
            if (selectedFields.feedbackRating && question.feedback?.rating) {
                children.push(new Paragraph({ children: [new TextRun({ text: "Rating: ", bold: true }), new TextRun({ text: `${question.feedback.rating}/5 stars` })], spacing: { after: 100 } }));
            }
            if (selectedFields.feedbackText && question.feedback?.comment) {
                children.push(new Paragraph({ children: [new TextRun({ text: "Feedback: ", bold: true }), new TextRun({ text: question.feedback.comment })], spacing: { after: 100 } }));
            }
            if (selectedFields.dateCreated) {
                const dateStr = question.createdAt?.toDate ? question.createdAt.toDate().toLocaleDateString() : 'N/A';
                children.push(new Paragraph({ children: [new TextRun({ text: "Created: ", bold: true }), new TextRun({ text: dateStr })], spacing: { after: 100 } }));
            }
            if (selectedFields.includeFollowUps && question.followUps?.length > 0) {
                children.push(new Paragraph({ text: "Follow-up Questions:", heading: HeadingLevel.HEADING_2, spacing: { before: 200, after: 100 } }));
                question.followUps.forEach((followUp, followUpIndex) => {
                    children.push(new Paragraph({ children: [new TextRun({ text: `Follow-up ${followUpIndex + 1}: `, bold: true }), new TextRun({ text: followUp.questionText || 'N/A' })], spacing: { after: 50 } }));
                    if (followUp.answer) {
                        children.push(new Paragraph({ children: [new TextRun({ text: "Answer: ", bold: true }), new TextRun({ text: followUp.answer })], spacing: { after: 100 } }));
                    }
                });
            }
        });
        const doc = new Document({ sections: [{ properties: {}, children: children, }] });
        return await Packer.toBlob(doc);
    };

    // Handle export (updated to support both CSV and Word)
    const handleExport = async () => {
        if (!processedQuestions.length) {
            toast.error('No questions to export');
            return;
        }
        try {
            setIsExporting(true);
            if (exportFormat === 'csv') {
                const csvContent = generateCSVContent(processedQuestions, exportFields);
                const blob = new Blob([csvContent], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `sds_questions_export_${new Date().toISOString().split('T')[0]}.csv`;
                link.click();
                window.URL.revokeObjectURL(url);
                toast.success('CSV exported successfully!');
            } else if (exportFormat === 'word') {
                const blob = await generateWordDocument(processedQuestions, exportFields);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `sds_questions_export_${new Date().toISOString().split('T')[0]}.docx`;
                link.click();
                window.URL.revokeObjectURL(url);
                toast.success('Word document exported successfully!');
            }
            setExportModalOpen(false);
        } catch (error) {
            console.error('Export failed:', error);
            toast.error('Export failed. Please try again.');
        } finally {
            setIsExporting(false);
        }
    };

    // Call the Cloud Function to send email
    const handleShare = useCallback(async (shareData) => {
        try {
            const functions = getFunctions();
            const shareQuestionThread = httpsCallable(functions, 'shareQuestionThreadByEmail');
            const result = await shareQuestionThread(shareData);
            if (result.data.success) {
                console.log('Question thread shared successfully:', result.data);
                return result.data;
            } else {
                throw new Error(result.data.error || 'Failed to share question thread');
            }
        } catch (error) {
            console.error('Error calling share function:', error);
            throw error;
        }
    }, []);

    // Open/close dialogs
    const openFollowUpDialog = (question) => {
        setSelectedQuestionForFollowUp(question);
        setFollowUpDialogOpen(true);
    };
    const closeFollowUpDialog = () => {
        setFollowUpDialogOpen(false);
        setFollowUpText('');
        setSelectedQuestionForFollowUp(null);
    };
    const openFeedbackDialog = (question) => {
        setSelectedQuestionForFeedback(question);
        if (question.feedback) {
            setFeedbackRating(question.feedback.rating || 0);
            setFeedbackText(question.feedback.comment || '');
        } else {
            setFeedbackRating(0);
            setFeedbackText('');
        }
        setFeedbackDialogOpen(true);
    };
    const closeFeedbackDialog = () => {
        setFeedbackDialogOpen(false);
        setFeedbackRating(0);
        setFeedbackText('');
        setSelectedQuestionForFeedback(null);
    };
    
    // Search handlers removed - now isolated in SearchInput component
    // Clear date filters
    const clearDateFilters = () => {
        setDateFrom('');
        setDateTo('');
    };

  const fetchQuestions = useCallback(() => {
    // ADD THIS BLOCK AT THE VERY TOP
    if (!user) {
        console.log('[DEBUG] No user object found, halting query (likely logout)');
        setQuestions([]); // Clear any existing data
        setLoading(false);
        return () => {}; // Return empty cleanup function
    }
    
    const userId = user?.uid || user?.id;
   
    if (!userId && !isAdmin) {
        setLoading(false);
        return () => {};
    }

    setLoading(true);
    setError(null);

    try {
        const questionsRef = collection(db, 'questions');
        const updatesRef = collection(db, 'businessUpdates');
        
        let questionsQuery;
        let updatesQuery;

        // Admin Global Feed Logic
        if (clientId === 'ALL' && isAdmin) {
            console.log('[DEBUG] ADMIN MODE: Fetching all questions and updates globally.');
            questionsQuery = query(questionsRef, orderBy('createdAt', 'desc'));
            updatesQuery = query(updatesRef, orderBy('createdAt', 'desc'));
        }
        // Standard User "All Clients" Logic  
        else if (clientId === 'ALL' && !isAdmin) {
            console.log('[DEBUG] USER MODE: Fetching all questions/updates for user:', userId);
            const userClauses = or(where('userId', '==', userId), where('fcfoId', '==', userId));
            questionsQuery = query(questionsRef, userClauses, orderBy('createdAt', 'desc'));
            updatesQuery = query(updatesRef, userClauses, orderBy('createdAt', 'desc'));
        }
        // Specific Client Logic
        else if (clientId) {
            console.log('[DEBUG] Fetching questions/updates for specific client:', clientId);
            
            if (isAdmin) {
                questionsQuery = query(questionsRef, where('clientId', '==', clientId), orderBy('createdAt', 'desc'));
                updatesQuery = query(updatesRef, where('clientId', '==', clientId), orderBy('createdAt', 'desc'));
            } else {
                const userClauses = or(where('userId', '==', userId), where('fcfoId', '==', userId));
                questionsQuery = query(questionsRef, and(where('clientId', '==', clientId), userClauses), orderBy('createdAt', 'desc'));
                updatesQuery = query(updatesRef, and(where('clientId', '==', clientId), userClauses), orderBy('createdAt', 'desc'));
            }
        } else {
            setQuestions([]);
            setLoading(false);
            return () => {};
        }

        const unsubscribeQuestions = onSnapshot(questionsQuery, (qSnapshot) => {
            const fetchedQuestions = qSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id, dataType: 'question' }));

            const unsubscribeUpdates = onSnapshot(updatesQuery, (uSnapshot) => {
                const fetchedUpdates = uSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id, dataType: 'update' }));
                
                // Combine and sort the results
                const combinedItems = [...fetchedQuestions, ...fetchedUpdates];
                combinedItems.sort((a, b) => (b.createdAt?.toMillis() || 0) - (a.createdAt?.toMillis() || 0));
                
                setQuestions(combinedItems);
                setLoading(false);
            }, (err) => {
                console.error('[ERROR] Error fetching business updates:', err);
                setError(`Failed to load business updates: ${err.message}`);
                setLoading(false);
            });

            return unsubscribeUpdates;
        }, (err) => {
            console.error('[ERROR] Error fetching questions:', err);
            setError(`Failed to load questions: ${err.message}`);
            setLoading(false);
        });

        return () => {
            unsubscribeQuestions();
        };

    } catch (err) {
        console.error('[ERROR] Error setting up unified feed listener:', err);
        setError(`Failed to load feed: ${err.message}`);
        setLoading(false);
        return () => {};
    }
}, [clientId, user?.uid, user?.id, isAdmin]);

    useEffect(() => {
        const unsubscribe = fetchQuestions();
        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [fetchQuestions]);

    // Debounce effects removed in favor of Search-on-Enter pattern

    // This useMemo hook contains all the client-side filtering,
    //  sorting, and data processing logic.
    const processedQuestions = useMemo(() => {
        let filtered = [...questions];
        const mainQuestions = filtered.filter(q => !q.parentId);
        const followUps = filtered.filter(q => q.parentId);
        const followUpMap = {};
        followUps.forEach(followUp => {
            if (!followUpMap[followUp.parentId]) {
                followUpMap[followUp.parentId] = [];
            }
            followUpMap[followUp.parentId].push(followUp);
        });
        Object.keys(followUpMap).forEach(parentId => {
            followUpMap[parentId].sort((a, b) => (a.createdAt?.toMillis() || 0) - (b.createdAt?.toMillis() || 0));
        });
        const questionsWithFollowUps = mainQuestions.map(item => {
    if (item.dataType === 'question') {
        // MERGE embedded followUps with mapped follow-ups
        const embeddedFollowUps = item.followUps || [];
        const mappedFollowUps = followUpMap[item.id] || [];
        const allFollowUps = [...embeddedFollowUps, ...mappedFollowUps];
        
        // Sort by creation date
        allFollowUps.sort((a, b) => {
            const aTime = a.createdAt?.toMillis ? a.createdAt.toMillis() : new Date(a.createdAt).getTime();
            const bTime = b.createdAt?.toMillis ? b.createdAt.toMillis() : new Date(b.createdAt).getTime();
            return aTime - bTime;
        });
        
        return { ...item, followUps: allFollowUps };
    } else if (item.dataType === 'update') {
        // Business Updates: MERGE embedded followUps with mapped follow-ups
        const embeddedFollowUps = item.followUps || [];
        const mappedFollowUps = followUpMap[item.id] || [];
        const allFollowUps = [...embeddedFollowUps, ...mappedFollowUps];
        
        allFollowUps.sort((a, b) => {
            const aTime = a.createdAt?.toMillis ? a.createdAt.toMillis() : new Date(a.createdAt).getTime();
            const bTime = b.createdAt?.toMillis ? b.createdAt.toMillis() : new Date(b.createdAt).getTime();
            return aTime - bTime;
        });
        
        return { ...item, followUps: allFollowUps };
    }
    return { ...item, followUps: followUpMap[item.id] || [] };
});
        
        // DEBUG: Log followUp merging for Decision Memos
        console.log('[ADMIN DEBUG] FollowUp merge check:', {
            totalItems: questionsWithFollowUps.length,
            itemsWithFollowUps: questionsWithFollowUps.filter(i => i.followUps?.length > 0).length,
            sampleItem: questionsWithFollowUps[0],
            sampleFollowUps: questionsWithFollowUps[0]?.followUps,
            decisionMemos: questionsWithFollowUps.flatMap(i => i.followUps || []).filter(f => f.type === 'decision_memo')
        });

        console.log('[ADMIN DEBUG] Client name enrichment check:', {
    clientId: clientId,
    hasClients: !!clients,
    clientsCount: clients?.length || 0,
    sampleQuestion: questionsWithFollowUps[0],
    firstClientId: questionsWithFollowUps[0]?.clientId
});

        if (clients) {
            questionsWithFollowUps.forEach(question => {
                const client = clients.find(c => c.id === question.clientId);
                question.clientName = client?.displayName || client?.name || 'Unknown Client';
                question.followUps.forEach(followUp => {
                    followUp.clientName = question.clientName;
                });
            });
        }
        if (dateFrom || dateTo) {
            const fromDate = dateFrom ? new Date(dateFrom) : null;
            const toDate = dateTo ? new Date(dateTo + 'T23:59:59') : null;
            filtered = questionsWithFollowUps.filter(question => {
                if (!question.createdAt?.toDate) return true;
                const questionDate = question.createdAt.toDate();
                if (fromDate && questionDate < fromDate) return false;
                if (toDate && questionDate > toDate) return false;
                return true;
            });
        } else {
            filtered = questionsWithFollowUps;
        }
        if (localSearchQuery.trim()) {
            const searchTerm = localSearchQuery.toLowerCase();
            filtered = filtered.filter(question => {
                const mainMatches =
                    question.questionText?.toLowerCase().includes(searchTerm) ||
                    question.answer?.toLowerCase().includes(searchTerm) ||
                    question.clientName?.toLowerCase().includes(searchTerm) ||
                    question.feedback?.comment?.toLowerCase().includes(searchTerm) ||
                    question.userNotes?.toLowerCase().includes(searchTerm);
                const followUpMatches = question.followUps.some(followUp =>
                    followUp.questionText?.toLowerCase().includes(searchTerm) ||
                    followUp.answer?.toLowerCase().includes(searchTerm)
                );
                return mainMatches || followUpMatches;
            });
        }
        switch (localSortOption) {
            case 'oldest':
                filtered.sort((a, b) => (a.createdAt?.toMillis() || 0) - (b.createdAt?.toMillis() || 0));
                break;
            case 'favorites':
                filtered.sort((a, b) => {
                    const aFavorited = isQuestionFavorited(a);
                    const bFavorited = isQuestionFavorited(b);
                    if (aFavorited && !bFavorited) return -1;
                    if (!aFavorited && bFavorited) return 1;
                    return (b.createdAt?.toMillis() || 0) - (a.createdAt?.toMillis() || 0);
                });
                break;
            case 'newest':
            default:
                filtered.sort((a, b) => (b.createdAt?.toMillis() || 0) - (a.createdAt?.toMillis() || 0));
                break;
        }
        return filtered;
    }, [questions, localSearchQuery, localSortOption, clientId, clients, dateFrom, dateTo, isQuestionFavorited]);

  // This is the new code to PASTE
    // Toggle question expansion
    const toggleExpansion = (questionId) => {
        setExpandedQuestions(prev => {
            const newSet = new Set(prev);
            if (newSet.has(questionId)) {
                newSet.delete(questionId);
            } else {
                newSet.add(questionId);
            }
            return newSet;
        });
    };

    // Enhanced timestamp formatting
    const formatTimestamp = (timestamp) => {
        if (!timestamp?.toDate) return 'Unknown date';
        const date = timestamp.toDate();
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);
        if (diffMins < 1) return 'Just now';
        if (diffMins < 60) return `${diffMins} min${diffMins !== 1 ? 's' : ''} ago`;
        if (diffHours < 24) return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
        if (diffDays < 7) return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
        return date.toLocaleDateString('en-US', {
            year: 'numeric', month: 'short', day: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    // Enhanced status display with icons and colors
    const getStatusDisplay = (status, aiStatus) => {
        if (status === 'answered') {
            return { label: 'Answered', color: 'success', icon: <CheckCircleIcon sx={{ fontSize: 16 }} /> };
        }
        if (status === 'pending') {
            if (aiStatus === 'processing') {
                return { label: 'Processing', color: 'info', icon: <CircularProgress size={14} /> };
            }
            return { label: 'Pending', color: 'warning', icon: <PendingIcon sx={{ fontSize: 16 }} /> };
        }
        if (status === 'error' || aiStatus === 'error') {
            return { label: 'Error', color: 'error', icon: <ErrorIcon sx={{ fontSize: 16 }} /> };
        }
        return { label: status || 'Unknown', color: 'default', icon: <ScheduleIcon sx={{ fontSize: 16 }} /> };
    };

     // Render follow-up questions
    const renderFollowUps = (followUps) => {
        if (!followUps || followUps.length === 0) return null;
        return (
            <Box sx={{ ml: 3, mt: 2, borderLeft: '3px solid #e0e0e0', pl: 2 }}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom sx={{ color: 'primary.main', fontSize: '1.1rem' }}>
                    <ChatIcon sx={{ fontSize: 18, mr: 1, verticalAlign: 'middle' }} />
                    Follow-up Questions ({followUps.length})
                </Typography>
                {followUps.map((followUp, index) => {
                    // NEW: Check if this is a BEP Decision Memo
                    if (followUp.type === 'decision_memo' && followUp.framework === 'business_evolution_pyramid') {
                        return (
                            <Box key={followUp.id} sx={{ mt: 3, mb: 3 }}>
                                <Paper elevation={2} sx={{ p: 2, bgcolor: '#f8f9fa', borderLeft: '4px solid #005DAA' }}>
                                    <Typography variant="subtitle2" fontWeight={700} gutterBottom sx={{ color: '#005DAA', display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <ArticleIcon fontSize="small" />
                                        Decision Memo (Business Evolution Pyramid)
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                                        Generated: {formatTimestamp(followUp.createdAt)}
                                    </Typography>
                                </Paper>
                                <BEPMemoDisplay followUpData={followUp} searchQuery={localSearchQuery} />
                            </Box>
                        );
                    }
                    
                    // NEW: Check if this is a standard Decision Memo
                    if (followUp.type === 'decision_memo') {
                        return (
                            <Box key={followUp.id} sx={{ mt: 3, mb: 3 }}>
                                <Paper elevation={2} sx={{ p: 2, bgcolor: '#f8f9fa', borderLeft: '4px solid #1976d2' }}>
                                    <Typography variant="subtitle2" fontWeight={700} gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <ArticleIcon fontSize="small" />
                                        Decision Memo
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                                        Generated: {formatTimestamp(followUp.createdAt)}
                                    </Typography>
                                </Paper>
                                <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
                                    <Box sx={{ 
                                        fontSize: '1rem', 
                                        lineHeight: 1.7,
                                        '& h1, & h2, & h3': { mt: 2, mb: 1, fontWeight: 600 },
                                        '& p': { mb: 1.5 },
                                        '& ul, & ol': { pl: 3, mb: 2 },
                                        '& li': { mb: 0.5 },
                                        '& strong': { fontWeight: 600 },
                                        '& table': { width: '100%', borderCollapse: 'collapse', mb: 2 },
                                        '& th, & td': { border: '1px solid #ddd', padding: '8px', textAlign: 'left' },
                                        '& th': { backgroundColor: '#f2f2f2', fontWeight: 600 }
                                    }}>
                                        <ReactMarkdown 
    remarkPlugins={[remarkGfm]}
    components={getHighlightedMarkdownComponents(localSearchQuery)}
>
    {followUp.response || followUp.answer}
</ReactMarkdown>
                                    </Box>
                                </Paper>
                            </Box>
                        );
                    }
                    
                    // EXISTING: Regular Q&A follow-up rendering
                    const followUpStatus = getStatusDisplay(followUp.status, followUp.aiStatus);
                    return (
                        <Card key={followUp.id} elevation={1} sx={{ mb: 1, bgcolor: 'grey.50' }}>
                            <CardContent sx={{ py: 1.5 }}>
                                <Box display="flex" alignItems="flex-start" gap={1} mb={1}>
                                    <Typography variant="body2" color="primary" fontWeight={600} sx={{ fontSize: '1rem' }}>
                                        Follow-up #{index + 1}:
                                    </Typography>
                                    <Typography variant="body2" sx={{ flexGrow: 1, fontSize: '1rem' }}>
                                        {localSearchQuery ? highlightSearchTerms(followUp.questionText, localSearchQuery) : followUp.questionText}
                                    </Typography>
                                </Box>
                                {followUp.answer && (
                                    <Box sx={{ mt: 1, p: 1.5, bgcolor: 'white', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                                        <Box sx={{ 
                                            fontSize: '1rem', 
                                            lineHeight: 1.7,
                                            '& p': { margin: 0, marginBottom: '0.5em' },
                                            '& p:last-child': { marginBottom: 0 },
                                            '& ul, & ol': { marginTop: '0.5em', marginBottom: '0.5em', paddingLeft: '1.5em' },
                                            '& li': { marginBottom: '0.25em' },
                                            '& strong': { fontWeight: 600 },
                                            '& table': { width: '100%', borderCollapse: 'collapse', marginTop: '0.5em', marginBottom: '0.5em' },
                                            '& th, & td': { border: '1px solid #ddd', padding: '8px', textAlign: 'left' },
                                            '& th': { backgroundColor: '#f2f2f2', fontWeight: 600 }
                                        }}>
                                            <ReactMarkdown 
    remarkPlugins={[remarkGfm]}
    components={getHighlightedMarkdownComponents(localSearchQuery)}
>
    {followUp.answer}
</ReactMarkdown>
                                        </Box>
                                    </Box>
                                )}
                                <Box display="flex" alignItems="center" gap={1} mt={1}>
                                    <Chip label={followUpStatus.label} size="small" color={followUpStatus.color} variant="filled" icon={followUpStatus.icon} />
                                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.9rem' }}>
                                        {formatTimestamp(followUp.createdAt)}
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    );
                })}
            </Box>
        );
    };
  
    const renderBusinessUpdateCard = (update) => {
    const canLeaveFeedback = true; // Always allow feedback on business updates
    const hasFeedback = update.feedback && update.feedback.rating;
    const isExpanded = expandedQuestions.has(update.id);
    const hasFollowUps = update.followUps && update.followUps.length > 0;
    return (
      <Card
        key={update.id}
        elevation={3}
        sx={{
          mb: 2,
          border: '1px solid',
          borderColor: 'secondary.light',
          backgroundColor: '#f3e5f5'
        }}
      >
        <CardContent sx={{ pb: 1 }}>
          <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
            <Box flex={1}>
                <Stack direction="row" spacing={1} alignItems="center" sx={{mb:1}}>
                    <Chip 
                        icon={<ArticleIcon />} 
                        label="SavvaiSignals" 
                        size="small" 
                        color="secondary" 
                        variant="filled" 
                        sx={{ fontWeight: 'bold' }}
                    />
                    {clientId === 'ALL' && (
                        <Chip 
                            label={`Client: ${update.clientName || 'Unknown Client'}`} 
                            size="small" 
                            color="secondary" 
                            variant="outlined" 
                        />
                    )}
                </Stack>
              <Typography
                variant="h6"
                component="h3"
                sx={{ fontSize: '1.2rem', fontWeight: 600, cursor: 'pointer', mb: 1, color: 'secondary.dark' }}
                onClick={() => toggleExpansion(update.id)}
              >
                {localSearchQuery ? highlightSearchTerms(update.title || 'SavvaiSignals', localSearchQuery) : (update.title || 'SavvaiSignals')}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <CalendarIcon sx={{ fontSize: 14 }} />
                {formatTimestamp(update.createdAt)}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={0.5}>
    {/* Favorite Toggle for Business Updates */}
    <Tooltip title={isUpdateFavorited(update) ? 'Remove from favorites' : 'Add to favorites'}>
        <IconButton
            onClick={() => handleUpdateFavoriteToggle(update.id, isUpdateFavorited(update))}
            sx={{
                color: isUpdateFavorited(update) ? 'warning.main' : 'text.secondary',
                '&:hover': {
                    color: 'warning.main',
                    backgroundColor: 'rgba(255, 152, 0, 0.08)'
                }
            }}
            aria-label={isUpdateFavorited(update) ? 'Remove from favorites' : 'Add to favorites'}
        >
            {isUpdateFavorited(update) ? <StarIcon /> : <StarBorderIcon />}
        </IconButton>
    </Tooltip>

    <Tooltip title={isExpanded ? 'Collapse' : 'Expand'}>
        <IconButton onClick={() => toggleExpansion(update.id)} aria-label={isExpanded ? 'Collapse' : 'Expand'}>
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
    </Tooltip>
</Box>
          </Box>
          <Collapse in={isExpanded} timeout="auto">
            <Divider sx={{ mb: 2 }} />
            <Box mb={2}>
              <Typography variant="subtitle2" fontWeight={600} gutterBottom sx={{ fontSize: '1.1rem' }}>Update Details:</Typography>
              <Paper elevation={0} variant="outlined" sx={{ p: 2, backgroundColor: 'white', borderColor: 'grey.200' }}>
                <Box sx={{ 
                    fontSize: '1rem', 
                    lineHeight: 1.7,
                    '& p': { margin: 0, marginBottom: '0.5em' },
                    '& p:last-child': { marginBottom: 0 },
                    '& ul, & ol': { marginTop: '0.5em', marginBottom: '0.5em', paddingLeft: '1.5em' },
                    '& li': { marginBottom: '0.25em' },
                    '& strong': { fontWeight: 600 },
                    '& h1, & h2, & h3': { marginTop: '1em', marginBottom: '0.5em' },
                    '& table': { width: '100%', borderCollapse: 'collapse', marginTop: '0.5em', marginBottom: '0.5em' },
                    '& th, & td': { border: '1px solid #ddd', padding: '8px', textAlign: 'left' },
                    '& th': { backgroundColor: '#f2f2f2', fontWeight: 600 }
                }}>
                  <ReactMarkdown 
    remarkPlugins={[remarkGfm]}
    components={getHighlightedMarkdownComponents(localSearchQuery)}
>
    {update.content || 'No content available.'}
</ReactMarkdown>
                </Box>
              </Paper>
            </Box>
            {/* User Notes Section for Business Updates */}
            <Box mb={2}>
              <Typography variant="subtitle2" fontWeight={600} gutterBottom sx={{ fontSize: '1.1rem' }}>
                Your Notes:
              </Typography>
              <Paper
                elevation={0}
                variant="outlined"
                sx={{
                  p: 2,
                  backgroundColor: 'white',
                  borderColor: 'grey.200'
                }}
              >
                {update.userNotes ? (
                  <Typography variant="body1" sx={{ fontSize: '1rem', whiteSpace: 'pre-wrap' }}>
                    {localSearchQuery ?
  highlightSearchTerms(update.userNotes, localSearchQuery) :
  update.userNotes
}
                  </Typography>
                ) : (
                  <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    No notes added yet.
                  </Typography>
                )}
                <Button
                  size="small"
                  startIcon={<EditIcon />}
                  onClick={() => handleEditNote(update)}
                  sx={{ mt: 1 }}
                >
                  {update.userNotes ? 'Edit Note' : 'Add Note'}
                </Button>
              </Paper>
            </Box>
             {hasFollowUps && renderFollowUps(update.followUps)}
            <Box display="flex" gap={1} mt={2} flexWrap="wrap">
                <Button variant="outlined" size="small" startIcon={<ReplyIcon />} onClick={() => { setSelectedUpdateForFollowUp(update); setBuFollowUpDialogOpen(true); }}>
                    Ask Follow-Up on this Update
                </Button>
                <Button
    variant="outlined"
    size="small"
    startIcon={<ShareIcon />}
    onClick={() => handleShareItem(update)}
    disabled={clientIsActive === false}
>
                    Share
                </Button>
                <Button
  variant="outlined"
  size="small"
  startIcon={<FeedbackIcon />}
  onClick={() => openFeedbackDialog(update)}
  color={hasFeedback ? 'secondary' : 'primary'}
  disabled={!canLeaveFeedback || clientIsActive === false}
>
  {hasFeedback ? 'Update Feedback' : 'Leave Feedback'}
</Button>
            </Box>
        </Collapse>
    </CardContent>
</Card>
    );
  };
    
    // REPLACE THE ENTIRE renderQuestionCard FUNCTION WITH THIS
     
// This is the new code to PASTE
    const renderQuestionCard = (question) => {
        const isExpanded = expandedQuestions.has(question.id);
        const hasAttachment = question.fileUrl || question.attachmentURL;

        // Original logic for user-facing view
        const isFavoritedByUser = isQuestionFavorited(question);
        
        // --- ADMIN-SPECIFIC CHANGE: Determine star/tooltip logic based on isAdmin flag ---
        const isFavoritedByAnyUser = question.favoritedBy && question.favoritedBy.length > 0;
        const showFilledStar = isAdmin ? isFavoritedByAnyUser : isFavoritedByUser;
        const tooltipTitle = isAdmin
            ? (isFavoritedByAnyUser ? 'Favorited by User' : 'Not Favorited')
            : (isFavoritedByUser ? 'Remove from favorites' : 'Add to favorites');

        const hasFollowUps = question.followUps && question.followUps.length > 0;
        // --- ADMIN-SPECIFIC CHANGE: Disable follow-up and feedback for admins ---
        const canAskFollowUp = question.status === 'answered' && clientIsActive && !isAdmin;
        const canLeaveFeedback = question.status === 'answered' && !isAdmin;
        
        const hasFeedback = question.feedback && question.feedback.rating;
        const statusDisplay = getStatusDisplay(question.status, question.aiStatus);

        return (
            <Card key={question.id} elevation={3} sx={{ mb: 2, transition: 'all 0.3s ease-in-out', border: showFilledStar ? '2px solid' : '1px solid transparent', borderColor: showFilledStar ? 'warning.main' : 'transparent', '&:hover': { boxShadow: 6, transform: 'translateY(-2px)' } }}>
                <CardContent sx={{ pb: 1 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                        <Box flex={1}>
                            {(clientId === 'ALL' || isAdmin) && question.clientName && (
                                <Chip label={`Client: ${question.clientName}`} size="small" color="primary" variant="outlined" sx={{ mb: 1, fontSize: '0.9rem' }} />
                            )}
                            <Box display="flex" alignItems="center" gap={1} mb={1} flexWrap="wrap">
                                {showFilledStar && <Chip icon={<StarIcon />} label="Favorite" size="small" color="warning" variant="filled" />}
                                {hasFollowUps && <Chip icon={<ChatIcon />} label={`${question.followUps.length} follow-up${question.followUps.length !== 1 ? 's' : ''}`} size="small" color="info" variant="outlined" />}
                                {hasFeedback && <Chip icon={<FeedbackIcon />} label={`${question.feedback.rating} star${question.feedback.rating !== 1 ? 's' : ''}`} size="small" color="secondary" variant="outlined" />}
                            </Box>
                            
                            <Typography variant="h6" component="h3" sx={{ fontSize: '1.2rem', fontWeight: 500, lineHeight: 1.3, cursor: 'pointer', mb: 1 }} onClick={() => toggleExpansion(question.id)}>
                                {localSearchQuery ? highlightSearchTerms(question.questionText, localSearchQuery) : question.questionText}
                            </Typography>

                            <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                                <Chip label={statusDisplay.label} size="small" color={statusDisplay.color} variant="filled" icon={statusDisplay.icon} />
                                {hasAttachment && <Chip icon={<AttachFileIcon />} label="Has Attachment" size="small" variant="outlined" />}
                                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <CalendarIcon sx={{ fontSize: 14 }} />{formatTimestamp(question.createdAt)}
                                </Typography>
                            </Box>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Tooltip title={tooltipTitle}>
                                <span>
                                    {/* --- ADMIN-SPECIFIC CHANGE: Favorite button is now disabled for admins --- */}
                                    <IconButton
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!isAdmin) { handleFavoriteToggle(question.id, isFavoritedByUser); }
                                        }}
                                        disabled={isAdmin}
                                        sx={{ color: showFilledStar ? 'warning.main' : 'text.secondary' }}
                                    >
                                        {showFilledStar ? <StarIcon /> : <StarBorderIcon />}
                                    </IconButton>
                                </span>
                            </Tooltip>

                            {/* --- ADMIN-SPECIFIC CHANGE: Share button is now hidden for admins --- */}
                            {!isAdmin && (
                                <Tooltip title="Share via Email">
                                    <IconButton onClick={(e) => { e.stopPropagation(); handleShareClick(question); }} size="small" disabled={clientIsActive === false} sx={{ color: 'primary.main' }}>
                                        <ShareIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                            <IconButton onClick={() => toggleExpansion(question.id)}>
                                {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                        </Box>
                    </Box>
                    {/* The rest of the function remains the same */}
                    <Collapse in={isExpanded} timeout="auto">
                        <Divider sx={{ mb: 2 }} />
                        {question.answer && (
                            <Box mb={2}>
                                <Typography variant="subtitle2" fontWeight={600} gutterBottom sx={{ fontSize: '1.1rem' }}>Answer:</Typography>
                                <Paper elevation={1} sx={{ p: 2, backgroundColor: 'grey.50', border: '1px solid', borderColor: 'grey.200' }}>
                                    <Box sx={{
                                        fontSize: '1rem',
                                        lineHeight: 1.7,
                                        '& p': { margin: 0, marginBottom: '0.5em' },
                                        '& p:last-child': { marginBottom: 0 },
                                        '& ul, & ol': { marginTop: '0.5em', marginBottom: '0.5em', paddingLeft: '1.5em' },
                                        '& li': { marginBottom: '0.25em' },
                                        '& strong': { fontWeight: 600 },
                                        '& h1, & h2, & h3': { marginTop: '1em', marginBottom: '0.5em' },
                                        '& table': { width: '100%', borderCollapse: 'collapse', marginTop: '0.5em', marginBottom: '0.5em' },
                                        '& th, & td': { border: '1px solid #ddd', padding: '8px', textAlign: 'left' },
                                        '& th': { backgroundColor: '#f2f2f2', fontWeight: 600 }
                                    }}>
                                        <ReactMarkdown 
    remarkPlugins={[remarkGfm]}
    components={getHighlightedMarkdownComponents(localSearchQuery)}
>
    {question.answer}
</ReactMarkdown>
                                    </Box>
                                </Paper>
                            </Box>
                        )}
    
                        <Box mb={2}>
                            <Typography variant="subtitle2" fontWeight={600} gutterBottom sx={{ fontSize: '1.1rem' }}>{isAdmin ? "Admin Note:" : "Your Notes:"}</Typography>
                            <Paper elevation={1} sx={{ p: 2, backgroundColor: 'grey.50', border: '1px solid', borderColor: 'grey.200' }}>
                                {question.userNotes ? (
                                    <Typography variant="body1" sx={{ fontSize: '1rem', whiteSpace: 'pre-wrap' }}>
                                        {localSearchQuery ? highlightSearchTerms(question.userNotes, localSearchQuery) : question.userNotes}
                                    </Typography>
                                ) : (
                                    <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>No notes added yet.</Typography>
                                )}
                                <Button size="small" startIcon={<EditIcon />} onClick={() => handleEditNote(question)} sx={{ mt: 1 }}>{question.userNotes ? 'Edit Note' : 'Add Note'}</Button>
                            </Paper>
                        </Box>
                        {hasAttachment && (<Box mb={2}><Button variant="outlined" startIcon={<AttachFileIcon />} href={question.fileUrl || question.attachmentURL} target="_blank" rel="noopener noreferrer" size="small">View Attachment</Button></Box>)}
                        {hasFeedback && (
                            <Box mb={2}>
                                <Typography variant="subtitle2" fontWeight={600} gutterBottom sx={{ fontSize: '1.1rem' }}>Your Feedback:</Typography>
                                <Paper elevation={1} sx={{ p: 2, bgcolor: 'info.50', border: '1px solid', borderColor: 'info.200' }}>
                                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                                        <Rating value={question.feedback.rating} readOnly size="small" />
                                        <Typography variant="body2" fontWeight={500}>({question.feedback.rating} star{question.feedback.rating !== 1 ? 's' : ''})</Typography>
                                    </Box>
                                    {question.feedback.comment && (<Typography variant="body2" sx={{ fontSize: '1rem' }}>{localSearchQuery ? highlightSearchTerms(question.feedback.comment, localSearchQuery) : question.feedback.comment}</Typography>)}
                                    <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>Submitted {formatTimestamp(question.feedback.submittedAt)}</Typography>
                                </Paper>
                            </Box>
                        )}
                        {hasFollowUps && renderFollowUps(question.followUps)}
                        <Box display="flex" gap={1} mt={2} flexWrap="wrap">
                            {canAskFollowUp && (<Button variant="outlined" startIcon={<ReplyIcon />} size="small" onClick={() => openFollowUpDialog(question)}>Ask Follow-Up</Button>)}
                            {canLeaveFeedback && (<Button variant="outlined" startIcon={<FeedbackIcon />} size="small" onClick={() => openFeedbackDialog(question)} color={hasFeedback ? 'secondary' : 'primary'}>{hasFeedback ? 'Update Feedback' : 'Leave Feedback'}</Button>)}
                        </Box>
                    </Collapse>
                </CardContent>
            </Card>
        );
    };

    if (loading) {
        return <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px"><CircularProgress /><Typography variant="body2" sx={{ ml: 2, fontSize: '1rem' }}>Loading questions...</Typography></Box>;
    }
    if (error) {
        return <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>;
    }

    return (
        <Box>
            <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid size={{ xs: 12, md: 4 }}>
                        <SearchInput 
                            onSearch={(value) => setLocalSearchQuery(value)} 
                            onClear={() => setLocalSearchQuery('')} 
                        />
                    </Grid>
                    <Grid size={{ xs: 6, md: 2 }}><TextField label="Date From" type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} size="small" fullWidth InputLabelProps={{ shrink: true }} /></Grid>
                    <Grid size={{ xs: 6, md: 2 }}><TextField label="Date To" type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} size="small" fullWidth InputLabelProps={{ shrink: true }} /></Grid>
                    <Grid size={{ xs: 6, md: 1 }}><Button variant="outlined" size="small" onClick={clearDateFilters} disabled={!dateFrom && !dateTo} fullWidth>Clear</Button></Grid>
                    <Grid size={{ xs: 6, md: 2 }}><FormControl size="small" fullWidth><InputLabel>Sort by</InputLabel><Select value={localSortOption} onChange={(e) => setLocalSortOption(e.target.value)} label="Sort by"><MenuItem value="newest">Newest First</MenuItem><MenuItem value="oldest">Oldest First</MenuItem><MenuItem value="favorites">Favorites First</MenuItem></Select></FormControl></Grid>
                    <Grid size={{ xs: 12, md: 1 }}><Button variant="contained" size="small" onClick={() => setExportModalOpen(true)} disabled={processedQuestions.length === 0} fullWidth sx={{ fontSize: '0.7rem', backgroundColor: 'primary.main', color: 'white', '&:hover': { backgroundColor: 'primary.dark' } }}>CONFIGURE & EXPORT</Button></Grid>
                </Grid>
                {(localSearchQuery || dateFrom || dateTo) && (
    <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontSize: '1rem' }}>
        {processedQuestions.length} question{processedQuestions.length !== 1 ? 's' : ''} found
        {localSearchQuery && ` for "${localSearchQuery}"`}
        {(dateFrom || dateTo) && (<span> • Filtered by date: {dateFrom || 'any'} to {dateTo || 'any'}</span>)}
    </Typography>
)}
            </Paper>
            {processedQuestions.length === 0 ? (
                <Paper elevation={1} sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="h6" color="text.secondary" gutterBottom sx={{ fontSize: '1.2rem' }}>
                        {localSearchQuery || dateFrom || dateTo ? 'No questions match your filters' : 'No questions yet'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '1rem' }}>
                        {localSearchQuery || dateFrom || dateTo ? 'Try adjusting your search terms or date range to see more questions.' : clientId === 'ALL' ? 'Questions will appear here once submitted.' : 'Submit your first question using the form on the left.'}
                    </Typography>
                </Paper>
            ) : (
                <Box>
    {processedQuestions.map(item => {
        if (item.dataType === 'question') {
            return renderQuestionCard(item);
        } else if (item.dataType === 'update') {
            return renderBusinessUpdateCard(item);
        }
        return null;
    })}
</Box>
            )}

            {/* All Dialogs */}
            <Dialog open={noteDialogOpen} onClose={() => setNoteDialogOpen(false)} maxWidth="sm" fullWidth>
                {/* Changes are in the Title and Label */}
                <DialogTitle>{isAdmin ? "Edit Admin Note" : "Edit Note"}</DialogTitle>
                <DialogContent>
                    <TextField 
                        autoFocus 
                        margin="dense" 
                        label={isAdmin ? "Your admin note" : "Your private note"} 
                        multiline 
                        rows={4} 
                        fullWidth 
                        variant="outlined" 
                        value={noteText} 
                        onChange={(e) => setNoteText(e.target.value)} 
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setNoteDialogOpen(false)}>Cancel</Button>
                    <Button onClick={() => handleSaveNote(selectedQuestionForNote?.id)} variant="contained">Save Note</Button>
                </DialogActions>
            </Dialog>
            
            <Dialog open={followUpDialogOpen} onClose={closeFollowUpDialog} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Ask Follow-Up Question
                    {selectedQuestionForFollowUp && (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            Regarding: "{selectedQuestionForFollowUp.questionText?.substring(0, 100)}..."
                        </Typography>
                    )}
                </DialogTitle>
                <DialogContent>
                    <TextField autoFocus multiline rows={4} fullWidth label="Your follow-up question" value={followUpText} onChange={(e) => setFollowUpText(e.target.value)} placeholder="What would you like to know more about?" sx={{ mt: 1 }} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeFollowUpDialog}>Cancel</Button>
                    <Button onClick={handleFollowUpSubmit} variant="contained" disabled={!followUpText.trim() || submittingFollowUp}>
                        {submittingFollowUp ? <CircularProgress size={20} /> : 'Submit Follow-Up'}
                    </Button>
                </DialogActions>
            </Dialog>
            
            <Dialog open={feedbackDialogOpen} onClose={closeFeedbackDialog} maxWidth="sm" fullWidth>
                <DialogTitle>
                    {selectedQuestionForFeedback?.feedback ? 'Update Feedback' : 'Leave Feedback'}
                    {selectedQuestionForFeedback && (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            For: "{selectedQuestionForFeedback.questionText?.substring(0, 100)}..."
                        </Typography>
                    )}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 1 }}>
                        <Typography variant="subtitle2" gutterBottom>How would you rate this answer?</Typography>
                        <Rating value={feedbackRating} onChange={(event, newValue) => setFeedbackRating(newValue)} size="large" sx={{ mb: 2 }} />
                        <TextField multiline rows={3} fullWidth label="Additional comments (optional)" value={feedbackText} onChange={(e) => setFeedbackText(e.target.value)} placeholder="What did you think of this answer? Any suggestions?" />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeFeedbackDialog}>Cancel</Button>
                    <Button onClick={handleFeedbackSubmit} variant="contained" disabled={feedbackRating === 0 || submittingFeedback}>
                        {submittingFeedback ? <CircularProgress size={20} /> : 'Submit Feedback'}
                    </Button>
                </DialogActions>
            </Dialog>
            
            {selectedQuestionForShare && (
                <ShareModal
                    open={shareModalOpen}
                    onClose={() => {
                        setShareModalOpen(false);
                        setSelectedQuestionForShare(null);
                    }}
                    question={selectedQuestionForShare}
                    followUps={selectedQuestionForShare.followUps || []}
                    onShare={handleShare}
                    user={user}
                />
            )}
            
            <Dialog open={exportModalOpen} onClose={() => setExportModalOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Configure Export</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                        <InputLabel>Export Format</InputLabel>
                        <Select value={exportFormat} label="Export Format" onChange={(e) => setExportFormat(e.target.value)}>
                            <MenuItem value="csv">CSV (.csv)</MenuItem>
                            <MenuItem value="word">Word Document (.docx)</MenuItem>
                        </Select>
                    </FormControl>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Select which fields to include in your export:
                    </Typography>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <FormControlLabel control={<Checkbox checked={exportFields.questionId} onChange={(e) => setExportFields(prev => ({...prev, questionId: e.target.checked }))}/>} label="Question ID" />
                            <FormControlLabel control={<Checkbox checked={exportFields.clientName} onChange={(e) => setExportFields(prev => ({...prev, clientName: e.target.checked }))}/>} label="Client Name" />
                            <FormControlLabel control={<Checkbox checked={exportFields.questionText} onChange={(e) => setExportFields(prev => ({...prev, questionText: e.target.checked }))}/>} label="Question Text" />
                            <FormControlLabel control={<Checkbox checked={exportFields.answerText} onChange={(e) => setExportFields(prev => ({...prev, answerText: e.target.checked }))}/>} label="Answer Text" />
                            <FormControlLabel control={<Checkbox checked={exportFields.dateCreated} onChange={(e) => setExportFields(prev => ({...prev, dateCreated: e.target.checked }))}/>} label="Date Created" />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <FormControlLabel control={<Checkbox checked={exportFields.feedbackRating} onChange={(e) => setExportFields(prev => ({...prev, feedbackRating: e.target.checked }))}/>} label="Feedback Rating" />
                            <FormControlLabel control={<Checkbox checked={exportFields.feedbackText} onChange={(e) => setExportFields(prev => ({...prev, feedbackText: e.target.checked }))}/>} label="Feedback Comments" />
                            <FormControlLabel control={<Checkbox checked={exportFields.userNotes} onChange={(e) => setExportFields(prev => ({...prev, userNotes: e.target.checked }))}/>} label="User Notes" />
                            <FormControlLabel control={<Checkbox checked={exportFields.includeFollowUps} onChange={(e) => setExportFields(prev => ({...prev, includeFollowUps: e.target.checked }))}/>} label="Include Follow-Up Questions" />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setExportModalOpen(false)}>Cancel</Button>
                    <Button onClick={handleExport} variant="contained" disabled={isExporting}>
                        {isExporting ? <CircularProgress size={20} /> : `Export ${exportFormat === 'csv' ? 'CSV' : 'Word Document'}`}
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Business Update Follow-up Dialog (Placeholder for Admin) */}
<Dialog open={buFollowUpDialogOpen} onClose={() => setBuFollowUpDialogOpen(false)} maxWidth="sm" fullWidth>
    <DialogTitle>
        Ask Follow-Up on SavvaiSignals
        {selectedUpdateForFollowUp && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Regarding: "{selectedUpdateForFollowUp.title?.substring(0, 100)}..."
            </Typography>
        )}
    </DialogTitle>
    <DialogContent>
        <Typography sx={{mt: 2}}>Admin follow-up functionality is not applicable in this view.</Typography>
    </DialogContent>
    <DialogActions>
        <Button onClick={() => setBuFollowUpDialogOpen(false)}>Close</Button>
    </DialogActions>
</Dialog>
        </Box>
    );
};
export default AdminExistingQuestions;
